module.exports = __webpack_public_path__ + "img/44914992001886.acf97829.png";